import React, { useEffect } from 'react';
import Dialog from "@shared/ui/molecules/Dialog";
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@shared/store/dialog.duck';
import {
  loadUserReservationDialog,
  resetDeskReservationDialog,
  SelectionState,
  selectIsDeskReservationLoading,
  selectSelectedFloor,
  selectSelectionState,
  selectShowCarParkMap,
  selectShowFloorMap,
  setSelectedParkingSpace,
  setShowCarParkMap
} from '@features/desks/store/deskReservation.duck';
import { ChooseOffice } from "./components/ChooseOffice";
import { ChooseFloor } from "./components/ChooseFloor";
import { LocationSelectionDone } from "./components/LocationSelectionDone";
import { ChooseArea } from "./components/ChooseArea";
import { MediumLoadingSpinner } from "@shared/ui/atoms/LoadingSpinner";
import { OfficeFloorMapWithDataProviders } from "./components/OfficeFloorMapWithDataProviders";
import { selectActiveDay } from '@features/whereabouts/store/editMovements.duck';
import { CarParkMapWithDataProviders } from "./components/CarParkMapWithDataProviders";
import { CarParkSpace } from '@features/whereabouts/services/CarParkingPlanService';
import { SideOfDay } from '@features/whereabouts/models/movements.models';

interface Props {
  payload: {
    onLocationSelected?: (selectedOffice?: number, selectedDesk?: number, selectedCarParkSpace?: number) => any,
    hideFavouriteControls?: boolean,
    showCarParkingOption?: boolean,
    sideOfDay?: SideOfDay,
  }
}

export default function ChooseLocationDialog(props: Props) {
  const dispatch = useDispatch();
  const selectionState = useSelector(selectSelectionState);
  const activeDate = useSelector(selectActiveDay);
  const isLoading = useSelector(selectIsDeskReservationLoading);
  const selectedFloor = useSelector(selectSelectedFloor);
  const showFloorMap = useSelector(selectShowFloorMap);
  const showCarParkMap = useSelector(selectShowCarParkMap);

  useEffect(() => {
    dispatch(loadUserReservationDialog({
      onLocationSelected: props?.payload?.onLocationSelected,
      hideFavouriteControls: props?.payload?.hideFavouriteControls,
      sideOfDay: props?.payload?.sideOfDay,
    }));
  }, [dispatch, props?.payload?.hideFavouriteControls, props?.payload?.onLocationSelected, props?.payload?.sideOfDay]);

  const close = () => {
    dispatch(closeDialog());
    dispatch(resetDeskReservationDialog());
  };

  const onCarParkingSpaceSelected = (carParkSpace: CarParkSpace) => {
    dispatch(setSelectedParkingSpace(carParkSpace));
    dispatch(setShowCarParkMap(false));
  }

  return (
    <>
      <Dialog isOpen={true} onClose={close}>
        {isLoading && !activeDate ? <>
          <MediumLoadingSpinner />
        </> : <>
          {selectionState === SelectionState.Office && activeDate && <ChooseOffice activeDate={activeDate} />}
          {selectionState === SelectionState.Floor && activeDate && <ChooseFloor activeDate={activeDate}/>}
          {selectionState === SelectionState.Area && <ChooseArea />}
          {selectionState === SelectionState.Done && <LocationSelectionDone showCarParkingOption={props?.payload?.showCarParkingOption}/>}
        </> }
      </Dialog>

      {showFloorMap && <OfficeFloorMapWithDataProviders className={'chooseLocationDialog__carParkMap'} />}
      {showCarParkMap && <CarParkMapWithDataProviders selectedOffice={selectedFloor}
                                                      onCarParkingSpaceSelected={onCarParkingSpaceSelected}
                                                      className={'chooseLocationDialog__carParkMap'} />}
    </>
  )
}

